import React from 'react';
import styled from '@emotion/styled';
import { Styles, Icon, P } from '@contently/toolkit';
import iconMap from '../iconMap';

const { colors } = Styles;

export const MenuBar = styled('div')`
  width: 100%;
  display: inline-block;
  vertical-align: top;
  background: ${Styles.colors.white};
  position: sticky;
  top: 0;
  box-shadow: 0px 1px 2px 0px #80808073;
  border-radius: 3px 3px 0 0;
  z-index: 1;
`;

export const MenuItemList = styled('ul')`
  display: inline-block;
  float: left;
  padding: 3px 2px 3px 0;
  margin: 3px;
  ${(props) => (props.divider ? `border-right: 1px solid #80808024;` : null)}
`;

function listItemStatusStyles(status) {
  const hoverStyles = `
    &:hover {
      color: ${Styles.colors.black};
      background-color: ${Styles.colors.grey.secondary}
    }
  `;

  switch (status) {
    case 'enabled':
      return `
        color: ${Styles.colors.grey.primary};

        ${hoverStyles}
      `;
    case 'disabled':
      return `
        color: ${Styles.colors.grey.secondaryDark};
        cursor: auto;
      `;
    case 'active':
      return `
        color: ${Styles.colors.black};
      `;
  }
}

export const MenuItemListItem = styled('li')`
  list-style: none;
  float: left;
  transition: all;
  color: #999;
  border-radius: 3px;
  text-align: center;
  border: 1px solid transparent;
  cursor: pointer;

  ${props => (props.size === 'small' ? 'width: 22px;' : 'width: 28px;')}
  ${props => (props.size === 'small' ? 'padding: 2px;' : 'padding: 5px 0px;')}
  ${props => (props.size === 'small' ? null : 'margin: 0 2px;')}
  ${(props) => listItemStatusStyles(props.status)}

  &:hover {
    i {
      ${(props) => {
        if (props.danger && props.status === 'enabled') {
          return `color: ${Styles.colors.red.primary};`;
        }
      }}
    }
  }
`;

export const FloatingMenuPositionWrapper = styled.div`
  position: absolute;
  bottom: ${props => props.bottom}px;
  left: ${props => props.left}px;
  z-index: 2;
`;

export const FloatingMenuWrapper = styled('div')`
  height: 36px;
  background-color: ${Styles.colors.white};
  border-radius: 3px;
  box-shadow: 0px 1px 2px 0px #80808073;
`;

export function MenuItem({ command, name, editorView, status, onClick, size }) {
  let clickCallback =
    onClick ||
    function handleClick(e){
      e.preventDefault();
      editorView.focus();
      command(editorView.state, editorView.dispatch, editorView);
    };

  if (status === 'disabled') clickCallback = () => {};

  const iconProps = iconMap[name];
  const icon = iconProps ? <Icon aria-label={name} {...iconProps} /> : <P>{name}</P>;

  return (
    <MenuItemListItem
      status={status}
      onClick={clickCallback}
      danger={!!iconProps.danger}
      size={size}
    >
      {icon}
    </MenuItemListItem>
  );
}

const SavingWrapper = styled.div`
  padding: 0px 4px;
  margin: 12px 3px;
  float: right;
  display: inline-block;
  transition: all 0.5s ease;

  i {
    margin-left: 5px;
  }
`;

export function SavingIndicator({ saving, saved, error }) {
  if (saving) {
    return (
      <SavingWrapper>
        <P>
          <span>Saving</span>
          <Icon type="spinner" spin="clockwise" />
        </P>
      </SavingWrapper>
    );
  } else if (error) {
    return (
      <SavingWrapper>
        <span>Error</span>
        <Icon type="x" color={colors.red.primary} />
      </SavingWrapper>
    );
  } else if (saved) {
    return (
      <SavingWrapper>
        <span>Saved</span>
        <Icon type="checkmark" color={colors.green.primary} />
      </SavingWrapper>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/menus/baseComponents.jsx